"use client"

import styled from "@emotion/styled"
import Image from "next/image"
import { Mobile } from "ui"

function scrollToLeadForm() {
  if (typeof window === "undefined") return
  const el = document.getElementById("lead-form")
  if (el) {
    try {
      el.scrollIntoView({ behavior: "smooth", block: "start" })
    } catch (e) {
      const top = el.getBoundingClientRect().top + window.scrollY
      window.scrollTo({ top, behavior: "smooth" })
    }
  }
}

const Section = styled.section`
  width: 100%;
  box-sizing: border-box;
  /* Max vertical margin 90px at 1920px viewport */
  margin: clamp(20px, 4.7vw, 45px) auto;
  padding: 0 clamp(16px, 4vw, 120px);
  direction: ltr;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 1760px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const TopText = styled.p`
  /* max 60px min 22px */
  font-size: clamp(21px, 3.2vw, 60px);
  line-height: 1;
  font-weight: 700;
  align-self: center;

  margin: 0;
  color: #1988e2;
  white-space: pre-line;
  max-width: 18em;
  padding-bottom: 1em;
  ${(p) => p.theme.breakpoints.down("sm")} {
    line-height: 1.2;
    max-width: none;
  }
`

const CTAButton = styled.button`
  background: #1988e2;
  color: #ffffff;
  font-weight: 700;
  font-size: clamp(20px, 2.2vw, 36px);
  line-height: 1.1;
  padding: 0.4em 1.6em;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.6em;
  direction: ltr;
  &:hover {
    background: #1472bb;
  }
  &:active {
    transform: translateY(2px);
  }
  &:focus-visible {
    outline: 3px solid #ffe600;
    outline-offset: 3px;
  }
`

const DogMobile = styled(Image)`
  width: clamp(150px, 90vw, 316px);
  height: auto;
  margin: -40px auto clamp(16px, 4vw, 32px);
  display: block;
`

export default function LowerContent() {
  return (
    <Section aria-labelledby="lower-content-heading">
      <Mobile>
        <DogMobile
          src="/landingpages/homeupgrades/second-dog-mobile.png"
          alt="Dog"
          width={316}
          height={218}
          priority
        />
      </Mobile>
      <TopText>
        בואו לגלות חוויית מגורים שמתחילה בחלום ונבנית בדיוק לפי הטעם שלכם.
        <br />
        באשטרום מגורים מחכה לכם הדירה שרציתם
      </TopText>

      <Mobile>
        <CTAButton aria-label="שדרגו" onClick={scrollToLeadForm}>
          שדרגו לי &gt;
        </CTAButton>
      </Mobile>
    </Section>
  )
}
